import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import Loader from "../subsidiary/Loader/Loader"
import Document from "./components/Document"
import { fetchDocuments } from "./documentsSlice"

const Documents = (props) => {
    const isLoaded = useSelector(state => state.documentsSlice.isLoaded)
    const documents = useSelector(state => state.documentsSlice.documents)
    const dispatch = useDispatch()

    const {
        loggedIn
    } = props

    useEffect(() => {
        dispatch(fetchDocuments())
    }, [dispatch])

    return (
        <>
            {isLoaded ?
                <>
                    <section className="main">
                        <div className="content-wrapper">
                            <div className="page-title-container">
                                <h1 className="page-title ">
                                    Документы
                                </h1>
                            </div>

                            <div style={{
                                width: '100%',
                                overflowX: 'hidden',
                                overflowY: 'auto',
                                maxWidth: '100%',
                                boxSizing: 'border-box'
                            }}>
                                {
                                    documents
                                        .filter(row => {
                                            if(loggedIn)
                                                return true;
                                            else if(row.document_skip_loggin === true && !loggedIn)
                                                return true;
                                            return false;
                                        })
                                        .map(document => {
                                        return <Document key={document.id} data={document} />
                                    })
                                }

                            </div>
                        </div>
                    </section>
                </>
                : <Loader />}
        </>
    )
}
export default Documents